<div *ngIf="rangeName$ | async as rangeName">
  <div class="flex gap-1 items-center px-2.5 py-1 rounded-full bg-hover cursor-pointer" [matMenuTriggerFor]="menu" matRipple [matMenuTriggerData]="{ name: rangeName }">
    <!-- <div *ngIf="rangeName === 'Live Tracking Data'" class="w-2 h-2 rounded-full bg-gray-500" [ngClass]="{'live bg-green-600 dark:bg-green-700': isConnectedSignalR$ | async}"></div> -->
    <div class="font-medium text-sm text-secondary whitespace-nowrap leading-3">{{rangeName}}</div>
    <mat-icon class="icon-size-4" svgIcon="mat_outline:more_vert"></mat-icon>
  </div>
</div>

<mat-menu #menu="matMenu">
  <ng-template matMenuContent let-name="name">
    <button mat-menu-item *ngFor="let item of itemsMenu" (click)="selectRange(item)" [ngClass]="{'bg-gray-100 dark:bg-gray-700': item === name}">{{item}}</button>
  </ng-template>
</mat-menu>